import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../../translations/translations';

const Wrapper = styled.div`
  display: inline-block;
  margin: 0 0 0.5em;
  padding: 0.3em 1em;
  background: #0176a2;
  color: #fff;
  font-weight: normal;
  font-size: 12px;

  p {
    margin-bottom: 0;
  }
`;

const GridItemCountdownLabels = ({ isFlashSale, countdownClassSuffix, id }) => (
  <div className={'countdownLabels'}>
    {isFlashSale && (
      <Wrapper
        className={`countdown-label ${countdownClassSuffix ? countdownClassSuffix : ''}`}
        id={`countdown_${id}`}
      >
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: getTranslation('countdownSaleTranslation') }}
        />
      </Wrapper>
    )}
  </div>
);

GridItemCountdownLabels.propTypes = {
  countdownClassSuffix: PropTypes.string,
  id: PropTypes.string.isRequired,
  isFlashSale: PropTypes.bool.isRequired
};

GridItemCountdownLabels.defaultProps = {
  countdownClassSuffix: undefined
};

export default GridItemCountdownLabels;
